import styled from 'styled-components';
import { mixins } from '@sy/component-library';

const { media } = mixins;

export const HookWrapper = styled.div`
	width: 100%;
	background-color: ${({ theme }) => theme.colors.grey[100]};
`;

export const HookContent = styled.div`
	width: 100%;
	max-width: 1300px;
	padding: 144px 84px;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	gap: 144px;

	${media.belowLarge`
		flex-direction: column;
		gap: 24px;
		padding: 48px 24px;
	`}
`;

export const HookInfoColumn = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	flex: 1;
`;

export const Content = styled.span`
	font-weight: 700;
	font-size: 2.4rem;
	line-height: 3.2rem;
	color: ${({ theme }) => theme.colors.grey[900]};
	margin-bottom: 24px;

	${media.belowLarge`
		text-align: center;
		font-size: 1.8rem;
		line-height: 2.4rem;
	`}
`;

export const LogoWrapper = styled.div`
	margin-bottom: 40px;

	${media.belowLarge`
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;		
	`}
`;

export const ImageWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
`;

export const TagList = styled.div`
	display: flex;
	flex-direction: row;
	gap: 8px;

	${media.belowLarge`
		width: 100%;
		justify-content: center;
	`}
`;

export const Tag = styled.span`
	border-radius: 4px;
	padding: 6px 12px;
	font-weight: 600;
	font-size: 1.6rem;
	line-height: 2rem;
	background-color: ${({ theme }) => theme.colors.background.dark};
	color: ${({ theme }) => theme.colors.white};
`;
